import Vue from 'vue'; // https://stackoverflow.com/questions/47332728/you-are-using-the-runtime-only-build-of-vue-where-the-template-compiler-is-not-a
import SvgVue from 'svg-vue'; // https://laravel-mix.com/extensions/svg-vue

// import { TabsPlugin } from 'bootstrap-vue'
import { FormDatepickerPlugin } from 'bootstrap-vue'
// import { BootstrapVue } from 'bootstrap-vue'
import Searchform from './components/Searchform.vue'

Vue.use(SvgVue)
// Vue.use(TabsPlugin)
Vue.use(FormDatepickerPlugin)

// Vue.use(BootstrapVue)

const $ = window.jQuery

let  vm = null

const elementSelector = '#vue-search'

const init = function() {
  let $element = $(elementSelector)

  if (!$element.length) {
    return false
  }
  
  // https://vuejs.org/v2/guide/instance.html
  vm = new Vue({
  	el: elementSelector,
    components: {
      Searchform,
    },
    data () {
      return {
        immobili_data: null,
        mobili_data: null,

        bandi_data: null,
        esiti_data: null,

        tabIndex: 0,
        tabTabs: []
      }
    },
    /*
  	template: `
			<div>
				...
			</div>
    */
    created () {
    },
    mounted () {
      if(window.immobili_data) {
        this.immobili_data = {}
        Object.keys(window.immobili_data).forEach(key => {
          this.immobili_data[key] = window.immobili_data[key];
        });
        this.tabTabs.push('Beni Immobili')
      }

      if(window.mobili_data) {
        this.mobili_data = {}
        Object.keys(window.mobili_data).forEach(key => {
          this.mobili_data[key] = window.mobili_data[key];
        });
        this.tabTabs.push('Beni Mobili')
      }

      if(window.bandi_data) {
        this.bandi_data = {}
        Object.keys(window.bandi_data).forEach(key => {
          this.bandi_data[key] = window.bandi_data[key];
        });
        this.tabTabs.push('Bandi')
      }

      if(window.esiti_data) {
        this.esiti_data = {}
        Object.keys(window.esiti_data).forEach(key => {
          this.esiti_data[key] = window.esiti_data[key];
        });
        this.tabTabs.push('Esiti')
      }
    },
    beforeDestroy () {
    },
    methods:{
    }
  });
}

const destroy = function() {
  if (vm) {
    vm.$destroy()
    vm = null
  }
}

export default {init, destroy}
